import { DangerButton } from '../../components/button/DangerButton';
import { SecondaryButton } from '../../components/button/SecondaryButton';
import { Modal } from '../../components/modal/Modal';
import { useUnassignDriverToVehicle } from '../../hooks/useUnassignDriverFromVehicle';
import { t } from '../../services/translation/translation';
import { noop } from '../../utils/common';

type Props = {
  onClose: () => void;
  vehicleId: string;
  driverKeys: string[];
  resetSelection: () => void;
};

export const RemoveDriverFromVehicleModal = ({ onClose, vehicleId, driverKeys, resetSelection }: Props) => {
  const { mutate: unassignDriver, isLoading } = useUnassignDriverToVehicle();

  const handleClose = isLoading ? noop : onClose;

  return (
    <Modal onClose={handleClose}>
      <Modal.Header onClose={handleClose} title={t('vehicle-route.remove-modal.title')} />
      <Modal.Body>
        <p className="text-sm font-normal text-gray-500 dark:text-gray-400">
          {t('vehicle-route.remove-modal.description')}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <DangerButton
          onClick={() =>
            unassignDriver(
              { driverKeys, vehicleId },
              {
                onSuccess: () => {
                  onClose();
                  resetSelection();
                },
              },
            )
          }
          isLoading={isLoading}
        >
          {t('common.remove')}
        </DangerButton>
        <SecondaryButton onClick={handleClose}>{t('common.cancel')}</SecondaryButton>
      </Modal.Footer>
    </Modal>
  );
};
